module.exports = __webpack_public_path__ + "media/images/common/img1-0b94782be5e37f425bc0b65d9f24ef7d.png";